import { CATALOG_API_COUNT } from '../catalogSize';
/** Blog author registry - byline name, title, avatar, bio, and entity links. */
export interface Author {
  /** stable url slug, e.g. "kevin-wang" (used by /blog/author/<slug>) */
  slug: string;
  name: string;
  title: string;
  /** root-relative avatar path under public/ */
  photo: string;
  /** one-paragraph bio shown on the author page and used for E-E-A-T */
  bio: string;
  /** authoritative external profiles (schema sameAs) */
  sameAs: string[];
  /** topical authority signals (schema knowsAbout) */
  knowsAbout: string[];
}

const AUTHORS: Record<string, Author> = {
  'Kevin Wang': {
    slug: 'kevin-wang',
    name: 'Kevin Wang',
    title: 'Founder, AnyAPI',
    photo: '/authors/kevin-wang.jpg',
    bio: `Kevin is the founder of AnyAPI, where he built the gateway that puts ${CATALOG_API_COUNT} scraping and data APIs behind one key and one wallet, priced in real dollars. He works on the routing engine, the cross-provider fallback layer, the MCP server, and the agent-payment rails.`,
    sameAs: [
      'https://github.com/kev1n',
      'https://www.linkedin.com/in/kevin-wang-08836a175/',
      'https://x.com/mxfp4',
    ],
    knowsAbout: [
      'APIs',
      'web scraping',
      'Model Context Protocol',
      'API gateways',
      'agent payments',
    ],
  },
};

/** Canonical URL for an author profile page. */
export function authorUrl(slug: string): string {
  return `https://getanyapi.com/blog/author/${slug}`;
}

/** Every registered author (for sitemap generation, author indexes). */
export function listAuthors(): Author[] {
  return Object.values(AUTHORS);
}

/** Resolve a frontmatter `author` string to a full Author, if registered. */
export function getAuthor(name?: string): Author | undefined {
  return name ? AUTHORS[name] : undefined;
}

/** Resolve an author by their url slug, if registered. */
export function getAuthorBySlug(slug: string): Author | undefined {
  return Object.values(AUTHORS).find((a) => a.slug === slug);
}
